import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import { COWTUXConfirmDialogComponent } from '@cowtux/components/confirm-dialog/confirm-dialog.component';

@NgModule({
    declarations: [
        COWTUXConfirmDialogComponent
    ],
    imports: [
        MatDialogModule,
        MatButtonModule
    ],
    entryComponents: [
        COWTUXConfirmDialogComponent
    ],
})
export class COWTUXConfirmDialogModule
{
}
